import React from "react"
import { ClientLogo } from "./client.styles"

const Client = props => <ClientLogo logoUrl={props.logoUrl}/>

export default Client
